export const stepsToGetLoan = [
  {
    id: "step-one",
    stepName: "Check Your Credit",
  },
  {
    id: "step-two",
    stepName: "Calculate Your Loan Payments",
  },
  {
    id: "step-three",
    stepName: "Research and Compare Lenders",
  },
  {
    id: "step-four",
    stepName: "Get Principal Approval for Loan Offers",
  },
  {
    id: "step-five",
    stepName: "Select a Lender and Complete Your Application",
  },

  {
    id: "step-six",
    stepName: "Review the Fine Print",
  },
  {
    id: "step-seven",
    stepName: "Sign the Loan Agreement and Receive Funds",
  },
];
